// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2bx2Y","buttons":"PendingPaymentAlert_buttons__2nIcy"};